import { Modal } from 'antd';
import { ChangeEvent, FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLoginMutation } from '../../../services';
import { User } from '../../../interfaces';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../hooks';
import { setCredentials } from '../../../slices';
import { handleServerError } from '../../../helpers';


interface IProps {
  isModalVisible: boolean;
  handleCancel: () => void;
  openVerifyEmail: () => void;
}

const Login: FC<IProps> = (props) => {
  const { isModalVisible, handleCancel, openVerifyEmail } = props;
  const dispatch = useAppDispatch();

  const [loginDto, setLoginDto] = useState<Pick<User, 'email' | 'password'>>({
    email: '',
    password: '',
  });

  const [login, { isLoading }] = useLoginMutation();

  const handleOk = () => {
    if (!loginDto.email || !loginDto.password) {
      toast.error('Please fill out all required fields');
    } else {
      login(loginDto)
        .unwrap()
        .then(({ user, accessToken }) => {
          dispatch(setCredentials({ user, accessToken }));
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('accessToken', accessToken as string);
          handleCancel();
        })
        .catch(handleServerError);
    }
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginDto(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Modal visible={isModalVisible} okButtonProps={{ disabled: isLoading }}
           okText={isLoading ? 'Logging in...' : 'Sign to My Account'}
           onOk={handleOk} onCancel={handleCancel}>
      <header><h1>Sign In</h1></header>
      <form>
        <div className="form-group">
          <label htmlFor="email">
            Email: <span className={"text-danger"}>*</span>
          </label>
          <input type="email" className="form-control" id="email" name={'email'}
                 value={loginDto.email} onChange={onChange} required/>
        </div>
        <div className="form-group">
          <label htmlFor="password">
            Password: <span className={"text-danger"}>*</span>
          </label>
          <input type="password" className="form-control" id="password"
                 name={'password'} value={loginDto.password}
                 onChange={onChange} required/>
        </div>
      </form>
      <hr/>
      <div className="center">
        <Link to="#" onClick={() => {
          handleCancel();
          openVerifyEmail();
        }}>I don't remember my password</Link>
      </div>
    </Modal>
  );
}

export default Login;